import { createAction } from "@reduxjs/toolkit"

export const getUserInfoAsync = createAction("register/getUserInfoAsync")
